import moment from 'moment';

function get_time(time) {
  let current_time;
  if (time) {
    current_time = moment(time);
  } else {
    current_time = moment();
  }
  return current_time.format('h:mm A');
}

function get_date_from_now(dateObj, type) {
  const sameDay = type === 'space' ? '[Today]' : 'h:mm A';
  const elseDay = type === 'space' ? 'MMM D, YYYY' : 'DD/MM/YYYY';
  const result = moment(dateObj).calendar(null, {
    sameDay: sameDay,
    lastDay: '[Yesterday]',
    lastWeek: elseDay,
    sameElse: elseDay,
  });
  return result;
}

function is_date_change(dateObj, prevObj) {
  const curDate = moment(dateObj).format('DD/MM/YYYY');
  const prevDate = moment(prevObj).format('DD/MM/YYYY');
  return curDate !== prevDate;
}

function scroll_to_bottom($element) {
  $element.animate(
    {
      scrollTop: $element[0].scrollHeight,
    },
    300
  );
}

function is_image(filename) {
  const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.webp)$/i;
  if (!allowedExtensions.exec(filename)) {
    return false;
  }
  return true;
}

function is_document_file(filename, file_type) {
  const typeStr = String(file_type || '').toLowerCase();
  if (typeStr === 'document' || typeStr.startsWith('application/')) return true;
  return /\.(pdf|doc|docx|xls|xlsx|ppt|pptx|txt|csv|zip)$/i.test(String(filename || ''));
}

const MEDIA_PLACEHOLDERS = new Set([
  '',
  '📎 Media',
  '📷 Image',
  '🎵 Audio',
  '🎬 Video',
  '📄 Document',
]);

function get_display_caption(content) {
  const text = String(content || '').trim();
  if (!text || text.startsWith('/files/') || text.startsWith('http')) return '';
  if (MEDIA_PLACEHOLDERS.has(text)) return '';
  return text;
}

function quote_label(preview, attachment, file_type) {
  const text = String(preview || '').trim();
  const url = String(attachment || '');
  if (text && !MEDIA_PLACEHOLDERS.has(text) && !text.startsWith('/files/') && !text.startsWith('http')) {
    return text;
  }
  if (url) {
    const file_name = url.split('?')[0].split('/').pop() || '';
    if (is_image(file_name) && !is_document_file(file_name, file_type)) return '📷 Image';
    return '📄 Document';
  }
  return text || '📷 Image';
}

async function get_rooms(email) {
  const res = await frappe.call({
    type: 'GET',
    method: 'wachat.api.room.get',
    args: {
      email: email,
    },
  });
  return await res.message;
}

async function get_messages(room, email, opts = {}) {
  const res = await frappe.call({
    method: 'wachat.api.message.get_all',
    args: {
      room,
      email,
      limit: opts.limit || 20,
      before_creation: opts.before_creation || '',
      before_name: opts.before_name || '',
    },
  });
  return res.message; // { messages, has_older }
}


async function send_message(content, user, room, email, attachment, reply_to) {
  const text = (content || "").trim();
  const file = attachment || "";
  if (!text && !file) return;
  try {
    await frappe.call({
      method: "wachat.api.message.send",
      args: {
        content: text || "📷 Image",
        user: user,
        room: room,
        email: email,
        attachment: file,
        reply_to: reply_to || "",
      },
    });
  } catch (error) {
    frappe.msgprint({
      title: __("Error"),
      message: (error && error.message) || __("Something went wrong. Please refresh and try again."),
    });
  }
}

async function get_settings(token) {
  const res = await frappe.call({
    type: 'GET',
    method: 'wachat.api.config.settings',
    args: {
      token: token,
    },
  });
  return await res.message;
}

async function mark_message_read(room) {
  try {
    await frappe.call({
      method: 'wachat.api.message.mark_as_read',
      args: {
        room: room,
      },
    });
  } catch (error) {
    //pass
  }
}


async function create_guest({ email, full_name, message }) {
  const res = await frappe.call({
    method: 'wachat.api.user.get_guest_room',
    args: {
      email: email,
      full_name: full_name,
      message: message,
    },
  });
  return await res.message;
}

async function set_typing(room, user, is_typing, is_guest) {
  try {
    await frappe.call({
      method: 'wachat.api.message.set_typing',
      args: {
        room: room,
        user: user,
        is_typing: is_typing,
        is_guest: is_guest,
      },
    });
  } catch (error) {
    //pass
  }
}

async function create_private_room(room_name, users, type) {
  await frappe.call({
    method: 'wachat.api.room.create_private',
    args: {
      room_name: room_name,
      users: users,
      type: type,
    },
  });
}

async function set_user_settings(settings) {
  await frappe.call({
    method: 'wachat.api.config.user_settings',
    args: {
      settings: settings,
    },
  });
}

function get_avatar_html(room_type, user_email, room_name) {
  let avatar_html;
  if (room_type === 'Direct' && 'desk' in frappe) {
    avatar_html = frappe.avatar(user_email, 'avatar-medium');
  } else {
    avatar_html = frappe.get_avatar('avatar-medium', room_name);
  }
  return avatar_html;
}

function set_notification_count(type) {
  const current_count = frappe.Wachat.settings.unread_count;
  if (type === 'increment') {
    $('#wachat-notification-count').text(current_count + 1);
    frappe.Wachat.settings.unread_count += 1;
  } else {
    if (current_count - 1 === 0) {
      $('#wachat-notification-count').text('');
    } else {
      $('#wachat-notification-count').text(current_count - 1);
    }
    frappe.Wachat.settings.unread_count -= 1;
  }
}

export {
  get_time,
  scroll_to_bottom,
  get_rooms,
  get_messages,
  get_settings,
  create_guest,
  send_message,
  get_date_from_now,
  is_date_change,
  mark_message_read,
  set_typing,
  is_image,
  create_private_room,
  set_user_settings,
  get_avatar_html,
  set_notification_count,
  quote_label,
  is_document_file,
  get_display_caption
};
